const constants = {
  GANTT_DATE_TIME_FORMAT: "%Y-%m-%d %H:%i",
  GANTT_TIME_FORMAT: "%H:%i",
};

export default constants;
